/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * calendarUtils.ts — calenda\1 \2tils (services/operator-web-app).
 */

/**
 * E5-S1: Calendar/slot helpers. Plan: 14 wireframes (Screen 05).
 */

/** Format date for <input type="date"> (yyyy-MM-dd). */
export function toInputDate(value: string): string {
  if (!value?.trim()) return '';
  const d = parseDate(value);
  if (!d) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Parse date from DD.MM.YYYY or YYYY-MM-DD. */
export function parseDate(value: string): Date | null {
  const s = value.trim();
  if (!s) return null;
  const iso = s.includes('-') && s.length >= 10;
  if (iso) {
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const parts = s.split(/[./]/);
  if (parts.length !== 3) return null;
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);
  if (Number.isNaN(day) || Number.isNaN(month) || Number.isNaN(year)) return null;
  const d = new Date(year, month, day);
  if (d.getDate() !== day || d.getMonth() !== month) return null;
  return d;
}

/** Format Date to DD.MM.YYYY for scenario field. */
export function toScenarioDate(d: Date): string {
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
}

/** Generate time slots from startHour to endHour (inclusive), stepMinutes. Returns "HH:mm" strings. */
export function generateTimeSlots(
  startHour: number,
  endHour: number,
  stepMinutes: number
): string[] {
  const slots: string[] = [];
  for (let h = startHour; h <= endHour; h++) {
    for (let m = 0; m < 60; m += stepMinutes) {
      if (h === endHour && m > 0) break;
      slots.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
    }
  }
  return slots;
}

export const DEFAULT_SLOT_START = 9;
export const DEFAULT_SLOT_END = 18;
export const DEFAULT_SLOT_STEP = 30;
